/* unplugin-vue-components disabled */var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "l-cascader-items"
  }, [_c('div', {
    staticClass: "picker-panel"
  }, _vm._l(_vm.list, function (area, index) {
    return _c('div', {
      key: index,
      staticClass: "panel-list"
    }, _vm._l(area, function (item) {
      return _c('div', {
        key: item.id,
        staticClass: "area-item",
        class: {
          'area-selected': _vm.selectedValueArr.includes(item.id)
        },
        on: {
          "click": function ($event) {
            return _vm.change(item, index);
          }
        }
      }, [_c('span', [_vm._v(_vm._s(item.value))])]);
    }), 0);
  }), 0)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };